"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.requirementLogEntryFilterSchema = void 0;
const QueryBuilder_1 = require("../QueryBuilder");
exports.requirementLogEntryFilterSchema = (0, QueryBuilder_1.createFilterSchema)({
    fields: {
        entryType: {
            options: { type: QueryBuilder_1.FieldType.Number },
            description: 'The kind of log entry.',
        },
        authorRole: {
            options: { type: QueryBuilder_1.FieldType.Number },
            description: 'Author role: system (service writes), admin (staff), or user (customer).',
        },
        severity: {
            options: { type: QueryBuilder_1.FieldType.Number },
            description: 'Severity contribution from this entry, if any.',
        },
        workflowState: {
            options: { type: QueryBuilder_1.FieldType.Number },
            description: 'Workflow state contribution from this entry, if any.',
        },
        message: {
            options: { type: QueryBuilder_1.FieldType.String },
            description: 'Plain-text message body.',
        },
        createdAt: {
            options: { type: QueryBuilder_1.FieldType.Date },
            description: 'Creation timestamp (the canonical timeline ordering key).',
        },
    },
});
//# sourceMappingURL=log-entry-filter-schema.js.map